import { Alert, AlertTitle, Grid } from '@mui/material';
import React from 'react';
import CAppSubTitle from '../../../../../app/components/CAppSubTitle';

const CTestUiAlerts = () => {
	return (
		<>
			<Grid container spacing={3}>
				<Grid item sm={3}>
					<CAppSubTitle title="Severity" subtitle="Error" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<Alert variant="standard" severity="error" onClose={() => null}>
								Alert - Standard
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="filled" severity="error" onClose={() => null}>
								Alert - Filled
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="outlined" severity="error" onClose={() => null}>
								Alert - Outlined
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="standard" severity="error" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Standard
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="filled" severity="error" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Filled
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="outlined" severity="error" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Outlined
							</Alert>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Severity" subtitle="Warning" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<Alert variant="standard" severity="warning" onClose={() => null}>
								Alert - Standard
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="filled" severity="warning" onClose={() => null}>
								Alert - Filled
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="outlined" severity="warning" onClose={() => null}>
								Alert - Outlined
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="standard" severity="warning" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Standard
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="filled" severity="warning" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Filled
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="outlined" severity="warning" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Outlined
							</Alert>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Severity" subtitle="Info" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<Alert variant="standard" severity="info" onClose={() => null}>
								Alert - Standard
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="filled" severity="info" onClose={() => null}>
								Alert - Filled
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="outlined" severity="info" onClose={() => null}>
								Alert - Outlined
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="standard" severity="info" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Standard
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="filled" severity="info" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Filled
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="outlined" severity="info" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Outlined
							</Alert>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Severity" subtitle="Success" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<Alert variant="standard" severity="success" onClose={() => null}>
								Alert - Standard
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="filled" severity="success" onClose={() => null}>
								Alert - Filled
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="outlined" severity="success" onClose={() => null}>
								Alert - Outlined
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="standard" severity="success" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Standard
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="filled" severity="success" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Filled
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="outlined" severity="success" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Outlined
							</Alert>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Colors" subtitle="Error" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<Alert variant="standard" color="error" onClose={() => null}>
								Alert - Standard
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="filled" color="error" onClose={() => null}>
								Alert - Filled
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="outlined" color="error" onClose={() => null}>
								Alert - Outlined
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="standard" color="error" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Standard
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="filled" color="error" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Filled
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="outlined" color="error" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Outlined
							</Alert>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Colors" subtitle="Warning" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<Alert variant="standard" color="warning" onClose={() => null}>
								Alert - Standard
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="filled" color="warning" onClose={() => null}>
								Alert - Filled
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="outlined" color="warning" onClose={() => null}>
								Alert - Outlined
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="standard" color="warning" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Standard
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="filled" color="warning" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Filled
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="outlined" color="warning" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Outlined
							</Alert>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Colors" subtitle="Info" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<Alert variant="standard" color="info" onClose={() => null}>
								Alert - Standard
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="filled" color="info" onClose={() => null}>
								Alert - Filled
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="outlined" color="info" onClose={() => null}>
								Alert - Outlined
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="standard" color="info" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Standard
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="filled" color="info" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Filled
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="outlined" color="info" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Outlined
							</Alert>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Colors" subtitle="Success" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<Alert variant="standard" color="success" onClose={() => null}>
								Alert - Standard
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="filled" color="success" onClose={() => null}>
								Alert - Filled
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="outlined" color="success" onClose={() => null}>
								Alert - Outlined
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="standard" color="success" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Standard
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="filled" color="success" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Filled
							</Alert>
						</Grid>
						<Grid item sm={12}>
							<Alert variant="outlined" color="success" onClose={() => null}>
								<AlertTitle>Alert Title</AlertTitle>
								Alert - Outlined
							</Alert>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</>
	);
};

export default CTestUiAlerts;
